import { forwardRef } from 'react';

import AutoCompleteContainer from './AutoCompleteContainer';
import AutoCompleteProvider from './Context/AutoCompleteProvider';

const AutoComplete = forwardRef((props, ref) => {
  return (
    <AutoCompleteProvider>
      <AutoCompleteContainer ref={ref} {...props} />
    </AutoCompleteProvider>
  );
});

AutoComplete.displayName = 'AutoComplete';

export default AutoComplete;
